import amber from "@mui/material/colors/amber";
import { createTheme } from "@mui/material/styles";
import backgroundImage from "./images/bg.jpg";
import logoImage from "./images/logo.png";

const MAIN_BLUE = "#47C2DC";

export default createTheme({
  images: {
    logo: logoImage,
    background: backgroundImage,
  },

  palette: {
    primary: {
      main: "#00a2c7",
    },
    secondary: {
      // light
      // dark
      main: MAIN_BLUE,
      contrastText: "#fff",
      // main: "#00a2c7"
    },
    notification: {
      ticketBadge: {
        // The number configures the shade
        main: amber[500],
        text: "#fff",
      },
    },
    importNotification: {
      main: amber[500],
      text: "#fff",
    },
    ticketsNotification: {
      main: "#fcc332",
      text: "#fff",
    },
    estateNotification: {
      main: "#e3cfde",
      contrastText: "#333",
    },
    postingsNotification: {
      main: MAIN_BLUE,
      text: "#fff",
    },

    documentsNotification: {
      main: "#eee",
      contrastText: "#333333",
      text: "#333333",
    },
    explainerBox: {
      main: "#777",
    },
  },
  typography: {
    fontFamily: ["Open Sans", "sans-serif", "serif"].join(","),
  },
});
